import React, { useState, SetStateAction } from 'react';
import classnames from 'classnames';
import styles from './DataProducts.module.scss';
import {
  DataProduct,
  DataProductTabType,
  DataVendor,
  DrmPage,
} from 'v2/models';
import { Tab, Tabs } from '@material-ui/core';
import useGetCustomTabs from 'v2/hooks/useGetCustomTabs';
import DataProductTabContent from './DataProductTabContent/DataProductTabContent';

const TABS: DataProductTabType[] = [
  {
    eventKey: 'details',
    title: `details`,
  },
  {
    eventKey: 'associations',
    title: `associations`,
  },
  {
    eventKey: 'restrictions',
    title: `restrictions`,
  },
  {
    eventKey: 'activity',
    title: `activity`,
  },
  {
    eventKey: 'files',
    title: `files`,
  },
];

interface DataProductDetailProps {
  dataProduct: DataProduct | null;
  dataVendor?: DataVendor;
  onUpdate: () => void;
}

const DataProductDetail = ({
  dataVendor,
  dataProduct,
  onUpdate,
}: DataProductDetailProps) => {
  const [selectedTab, setTabSelected] = useState<
    DataProductTabType['eventKey']
  >(TABS[0].eventKey);
  const handleTabChange = (
    event: React.ChangeEvent<unknown>,
    newValue: SetStateAction<DataProductTabType['eventKey']>
  ) => {
    setTabSelected(newValue);
  };

  const { data: customTabs } = useGetCustomTabs(DrmPage.DATASET);

  if (!dataProduct) {
    return null;
  }

  return (
    <div className={classnames(styles.tabs_container)}>
      <Tabs
        className={classnames(styles.scrolling_tabs)}
        value={selectedTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        indicatorColor="primary"
        textColor="primary"
        data-cy="dataset:tabs"
      >
        {TABS.map((item) => (
          <Tab
            key={item.eventKey}
            className={classnames(styles.tabs)}
            value={item.eventKey}
            label={`${item.title}`}
            disableRipple
          ></Tab>
        ))}
        {customTabs?.results.map((tab) => (
          <Tab
            key={tab.id}
            className={classnames(styles.tabs)}
            value={tab.name}
            label={`${tab.name}`}
            disableRipple
          ></Tab>
        ))}
      </Tabs>
      <div>
        <DataProductTabContent
          selectedTab={selectedTab}
          dataVendor={dataVendor}
          dataProduct={dataProduct}
          customTabs={customTabs}
          TABS={TABS}
          onUpdate={onUpdate}
        />
      </div>
    </div>
  );
};

export default DataProductDetail;
